module.exports = __webpack_public_path__ + "img/carousel.3eedc902.svg";